export default function ProcessSteps() {
  const steps = [
    {
      number: "01",
      title: "도면 검토 및 상담",
      description: "고객의 요구사항과 도면을 면밀히 검토하고 최적의 제작 방안을 제시합니다.",
      icon: "ri-file-search-line"
    },
    {
      number: "02",
      title: "목재 선정 및 가공",
      description: "용도에 맞는 최적의 목재를 선정하고 정밀한 1차 가공을 진행합니다.",
      icon: "ri-scissors-cut-line"
    },
    {
      number: "03",
      title: "정밀 제작",
      description: "숙련된 기술진이 도면에 따라 정밀하게 목형을 제작합니다.",
      icon: "ri-hammer-line"
    },
    {
      number: "04",
      title: "표면 처리",
      description: "목형의 내구성과 정밀도를 높이기 위한 표면 처리 작업을 진행합니다.",
      icon: "ri-brush-line"
    },
    {
      number: "05",
      title: "품질 검사",
      description: "엄격한 품질 기준에 따라 치수와 형상을 정밀하게 검사합니다.",
      icon: "ri-search-eye-line"
    },
    {
      number: "06",
      title: "납품 및 A/S",
      description: "안전하게 포장하여 납품하며, 지속적인 사후관리 서비스를 제공합니다.",
      icon: "ri-truck-line"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">목형 제작 공정</h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-8"></div>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            체계적인 제작 공정과 철저한 품질 관리로<br />
            최상의 목형을 제작합니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all border-t-4 border-[#D4AF37] group"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="text-5xl font-bold text-[#D4AF37]/20 group-hover:text-[#D4AF37]/30 transition-all">
                  {step.number}
                </div>
                <div className="w-14 h-14 bg-gradient-to-br from-[#1e3a8a] to-[#2563eb] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#1e3a8a] to-[#2563eb] rounded-2xl p-10 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">맞춤형 목형 제작 상담</h3>
          <p className="text-lg mb-6 text-white/90">
            소량 제작부터 대량 생산까지, 고객의 요구에 맞는 최적의 솔루션을 제공합니다
          </p>
          <a
            href="tel:02-2263-8248"
            className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#C19B2B] text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            전화 상담: 02-2263-8248
          </a>
        </div>
      </div>
    </section>
  );
}
